import {OFFER_TYPE} from 'pages/ProductsPages/constant'

export const LIST_TABS_RECHARGE = [
  {
    label: 'IUpfrontPlan',
    value: OFFER_TYPE.ONCE,
  },
  {
    label: 'IMonthlyPlan',
    value: OFFER_TYPE.MONTHLY,
  },
]

export const LIST_TABS_LICENSE = [
  {
    label: 'IRechargeableBulk',
    value: OFFER_TYPE.ONCE,
  },
  {
    label: 'IRechargeableMonthly',
    value: OFFER_TYPE.MONTHLY,
  },
  {
    label: 'IManual',
    value: OFFER_TYPE.ANUAL,
  },
]

export const LIST_COLUMN_TABLE = [
  {
    label: '',
    key: 'checkbox',
  },
  {
    label: 'ICustomerOrganizationName',
    key: 'orgName',
  },
  {
    label: 'IAccount',
    key: 'account',
  },
  {
    label: 'ICustomerRepresentative',
    key: 'representative',
  },
  {
    label: 'IActiveProduct',
    key: 'activeProduct',
  },
  {
    label: 'IUsePeriod',
    key: 'usePeriod',
  },
  {
    label: 'IRemark',
    key: 'remark',
  },
]

export const SELECT_ORGANIZATION = [
  {label: 'ICustomerOrganizationName', value: 'orgName'},
  {label: 'IEmailAddress', value: 'email'},
]
